import { format, parseISO } from 'date-fns';
import { ReportStatus, ReportTableType } from '../../../Api/Reports/reportsApi';

export { tableTypeLabel } from '../../../utils/tableTypeLabel';

type ChipColor = 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

export const tableTypeChipColor = (type: ReportTableType): ChipColor => {
  switch (type) {
    case 'inventory':
      return 'success';
    case 'project':
      return 'info';
    case 'order':
      return 'warning';
    case 'case':
      return 'primary';
    case 'related_project_assets':
      return 'secondary';
    default:
      return 'default';
  }
};

export const reportStatusLabel = (status: ReportStatus): string => {
  switch (status) {
    case 'paused':
      return 'Paused';
    case 'expired':
      return 'Expired';
    default:
      return 'Active';
  }
};

export const reportStatusChipColor = (status: ReportStatus): ChipColor => {
  switch (status) {
    case 'paused':
      return 'warning';
    case 'expired':
      return 'default';
    default:
      return 'success';
  }
};

export const formatReportDate = (value: string | null | undefined): string => {
  if (!value) return '—';
  try {
    return format(parseISO(value), 'MMM d, yyyy');
  } catch {
    return '—';
  }
};
